import React from 'react';
import Heading from '../../heading/heading';
import Footer from '../../footer/footer';
import './road-work.css';
import {Carousel, CarouselItem} from 'react-bootstrap';
import NewRoad from './images/new-road.jpg';
import RoadPlots from './images/road-plots.jpeg';
import RoadWorker  from './images/road-working.jpg';
import StreetRoad from './images/street-road.jpeg';
import CompanyRoad from './images/road-work.jpeg';



function RoadWork() {
  return (
      <div>
          <div className='roadwork_page'>
     <Heading />
     <div className='road_page_content'>
     <div className='rd_content_container'>
        <Carousel>

              <CarouselItem>
                <div className="rd_Carousel_image Carousel_rd_one ">
                   <div className="rd_Carousel_black_background"></div>
                </div>
              <Carousel.Caption>
              <h3 className='rd_carousel_heading'>
SubCride earth Work 
                </h3>
<p className='rd_carousel_caption'>
   We Will Provide the service, which subcride to water rolling of all works.
  </p>
              </Carousel.Caption>
              </CarouselItem>

              <CarouselItem>
                <div className="rd_Carousel_image Carousel_rd_two">
                <div className="rd_Carousel_black_background"></div>
                   
                </div>
              <Carousel.Caption>
              <h3 className='rd_carousel_heading'>
               kravol Billing Road work to water Rolling
                </h3>
<p className='rd_carousel_caption'>
  We Have High tech mechines for kravol Billing and water Rolling work. feel free to contact us.
  </p>
              </Carousel.Caption>
              </CarouselItem>

              <CarouselItem>
                <div className="rd_Carousel_image  Carousel_rd_three">
                <div className="rd_Carousel_black_background"></div>
                   
                </div>
              <Carousel.Caption>
              <h3 className='rd_carousel_heading'>
               W MM Mixing WETMIX Water rolling.
                </h3>
<p className='rd_carousel_caption'>we will provide W MM  and water rolling services for you. Just contact us for more info.
  </p>
              </Carousel.Caption>
              </CarouselItem>

              <CarouselItem>
                <div className="rd_Carousel_image  Carousel_rd_four">
                <div className="rd_Carousel_black_background"></div>
                   
                </div>
              <Carousel.Caption>
              <h3 className='rd_carousel_heading'>
                1` Mini Plant Tar Road.
                </h3>
<p className='rd_carousel_caption'>Also, We provide 1` Mini plant tar roads. contact us for more info
  </p>
              </Carousel.Caption>
              </CarouselItem>

              <CarouselItem>
                <div className="rd_Carousel_image  Carousel_rd_five">
                <div className="rd_Carousel_black_background"></div>
                   
                </div>
              <Carousel.Caption>
              <h3 className='rd_carousel_heading'>
                2` Mini Plant Tar Road.
                </h3>
<p className='rd_carousel_caption'>Also, We provide 2` Mini plant tar roads. contact us for more info.
  </p>
              </Carousel.Caption>
              </CarouselItem>
       
        </Carousel>



      </div>

 </div>
      <Footer />
        </div>
        
      </div>
  )
}

export default RoadWork